import ngmodule from '../ngmodule';

export default ngmodule;